export * from './environment';
export * from './path';
export { ERROR_MESSAGE } from './message';
export * from './local-storage';
export * from './count-down-time';
export * from './table';
// HARD CODE FOR Lexikon TEAM ONLY
export const LexikonTeamId = 'be852435-e5ec-4313-89cf-225711e1fb31';
